module.exports = __webpack_public_path__ + "static/media/image-money-stack@2x.c070e04e.png";